(function () {
	'use strict';

	angular.module('app.core')
		.directive('focusOn', focusOn);

	focusOn.$inject = ['$timeout', '$parse'];
	function focusOn($timeout, $parse) {
		return {
			link: function (scope, element, attrs) {
				var model = $parse(attrs.focusOn);
				scope.$watch(model, function (value) {
					if (value === true) {
						$timeout(function () {
							element[0].focus();
						});
					}
				});
				element.bind('blur', function () {
					scope.$apply(model.assign(scope, false));
				});
			}
		};
	}
})();
